// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + ({"18":"product","32":"HomeView","49":"join","631":"contact","678":"AboutView"}[chunkId] || chunkId) + "." + {"18":"5b546d80","32":"35f35265","49":"5c4dba9c","259":"9660288d","408":"8e3533dc","473":"a23e4c63","631":"aa0b6b9b","678":"dfe3aa0d","743":"982069f5","804":"37bb7899"}[chunkId] + ".css";
};